export default __webpack_public_path__ + "static/background-home-mobile-eedb007c99adb2113052004d70fd4d18.png";